import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  BookOpen,
  Target,
  Award,
  Settings,
  LogOut,
  User,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';
import IconeEscola from '../assets/iconeescola.png';

const Sidebar = ({ user, onLogout, onOpenProfile, onShowCertificates, onShowMyCourses, collapsed, onToggle }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItem = (to, Icon, label, onClick) => {
    const active = to ? isActive(to) : false;
    const cls = `sidebar-item${active ? ' active' : ''}`;

    if (onClick) {
      return (
        <button key={label} className={cls} onClick={onClick} title={collapsed ? label : undefined}>
          <Icon size={18} />
          <span className="sidebar-item-label">{label}</span>
        </button>
      );
    }
    return (
      <Link key={label} to={to} className={cls} title={collapsed ? label : undefined}>
        <Icon size={18} />
        <span className="sidebar-item-label">{label}</span>
      </Link>
    );
  };

  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <img src={IconeEscola} alt="Escola de Suporti" />
        {!collapsed && <span className="sidebar-logo-text">Escola de Suporti</span>}
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        <span className="sidebar-section-label">Principal</span>
        {navItem('/dashboard', LayoutDashboard, 'Dashboard')}
        {navItem('/assessments', Target, 'Avaliações')}
        {navItem(null, Award, 'Certificados', onShowCertificates)}

        <span className="sidebar-section-label" style={{ marginTop: '0.75rem' }}>Cursos</span>
        {navItem(null, BookOpen, 'Meus Cursos', onShowMyCourses)}

        {(user?.role === 'admin' || user?.role === 'coordinator') && (
          <>
            <span className="sidebar-section-label" style={{ marginTop: '0.75rem' }}>Administração</span>
            {navItem('/admin', User, 'Painel Admin')}
          </>
        )}
      </nav>

      {/* Footer actions */}
      <div className="sidebar-footer" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <button
          className="sidebar-item"
          onClick={onOpenProfile}
          title={collapsed ? 'Perfil' : undefined}
        >
          <Settings size={18} />
          <span className="sidebar-item-label">Perfil</span>
        </button>
        <button
          className="sidebar-item"
          onClick={onLogout}
          title={collapsed ? 'Sair' : undefined}
          style={{ color: '#f87171' }}
        >
          <LogOut size={18} />
          <span className="sidebar-item-label">Sair</span>
        </button>

        {/* Collapse toggle */}
        <button className="sidebar-toggle" onClick={onToggle} title={collapsed ? 'Expandir menu' : 'Recolher menu'}>
          {collapsed ? <ChevronRight size={16} /> : <><ChevronLeft size={16} /><span>Recolher</span></>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
